import { useState, useContext, useEffect } from "react";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Modal,
  Table,
} from "react-bootstrap";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import es from "react-phone-input-2/lang/es.json";
import ReclamoContext from "../../context/reclamo/reclamoContext";
import ParametrosContext from "../../context/Parametros/ParametrosContext";
import TokenContext from "../../context/Token/TokenContext";
import DragDrop from "../../Utils/DragDrop";
import { onSubmitForm } from "./Utils/onSubmitForm";
import { ValidaBlur } from "./Utils/onChangeBlur";
import ModalAceptar from "./Utils/Modal";
import EjemploCartaComponent from "./Utils/EjemploCarta";
import VideoComponent from "./Utils/Video";
import { Snackbar, CircularProgress } from '@material-ui/core';
import Swal from 'sweetalert2'

const ReclamosForm = ({ history }) => {
  const parametrosContext = useContext(ParametrosContext);
  const { parametros, comunas, Get_RegionId_F } = parametrosContext;

  const tokenContext = useContext(TokenContext);
  const { Get_Token_F, token, Active_Token_F, active_token } = tokenContext;

  const [Errores, setErrores] = useState({});
  const reclamoContext = useContext(ReclamoContext);

  const {
    data_usuario,
    Get_Data_Change_F,
    Send_Reclamo_F,
    archivos,
    Get_Archivos_F,
    Get_Phone_F,
    phone_number,
    reclamos_temporales,
    enviando_data,
    Enviado_F,
    primera_llamada,
    existente_error,
    plazo_error
  } = reclamoContext;

  const [IsAdecuando, setIsAdecuando] = useState(false);
  const [IsapreName, setIsapreName] = useState("");
  const [Temporales, setTemporales] = useState(false);
  const [ShowForm, setShowForm] = useState(false);
  const [ComparadorError, setComparadorError] = useState(false);
  const [ShowModal, setShowModal] = useState(false);

  useEffect(() => {
    if (reclamos_temporales !== null && reclamos_temporales.length !== 0) {
      setTemporales(true);
    }
  }, [reclamos_temporales]);

  useEffect(() => {
    if (existente_error !== ComparadorError) {
      Swal.fire({
        icon: 'error',
        text: 'Usted ya cuenta con un reclamo creado',
      })
    }
    setComparadorError(existente_error)
  }, [existente_error]);

  useEffect(() => {
    if (plazo_error !== ComparadorError) {
      Swal.fire({
        icon: 'error',
        text: 'El plazo maximo para ingresar el reclamos era el 31 de Mayo de 2025',
      })
    }
    setComparadorError(plazo_error)
  }, [plazo_error]);

  useEffect(() => {
    if (ShowForm) {
      window.gtag("event", "Inicio de reclamo alza de precio base", {
        event_category: "Reclamo por alza en planes de Isapres",
        event_label: "Trámite - ID 0300520010"
      });
    }
  }, [ShowForm]);

  const [Valid, setValid] = useState(false)

  const onKey = (e) => {

    let tecla = (document.all) ? e.keyCode : e.which;
    if (tecla === 8 || tecla === 32) {
      setValid(true)
      return true;
    }

    let patron = /[A-Za-z0-9]/;
    let tecla_final = String.fromCharCode(tecla);

    setValid(patron.test(tecla_final));
    return Valid

  }

  const onChange = (e) => {


    if (e.target.name === "region") {
      Get_RegionId_F(e.target.value);
      Get_Data_Change_F({
        ...data_usuario,
        comuna: "",
        region: e.target.value,
      });
      return;
    }

    if (e.target.name === "isapre") {
      if (e.target.value === '') {
        setIsAdecuando(false)
      } else {
        const isapreArray = parametros.isapres.find(
          (x) => x.codigo_isapre === Number(e.target.value)
        );

        if (isapreArray.is_adecuando) {
          setIsAdecuando(false);
        } else {
          setIsAdecuando(true);
          setIsapreName(isapreArray.nombre_isapre);
        }
      }
    }


    if (e.target.name === "nombres" || e.target.name === "apellido_p" || e.target.name === "apellido_m" || e.target.name === "direccion_nombre" || e.target.name === "direccion_nro" || e.target.name === "direccion_nro_dpto") {
      if (Valid) {
        Get_Data_Change_F({
          ...data_usuario,
          [e.target.name]: e.target.value,
        });

      } else {
        setValid(true)
      }
    } else {
      Get_Data_Change_F({
        ...data_usuario,
        [e.target.name]: e.target.value,
      });
    }

  };

  const onSubmit = (e) => {
    setShowModal(false)
    Send_Reclamo_F(true);
    Enviado_F(true);
    // e.preventDefault();

    // let validacion = onSubmitForm(
    //   data_usuario,
    //   Errores,
    //   setErrores,
    //   phone_number,
    //   archivos
    // );

    // if (validacion === true) {
    //   Send_Reclamo_F(true);
    //   Enviado_F(true);
    // }
  };

  const showModalAceptar = (e) => {
    e.preventDefault();

    let validacion = onSubmitForm(
      data_usuario,
      Errores,
      setErrores,
      phone_number,
      archivos
    );
    
    if (validacion === true) {
      setShowModal(true)
    }
  }
  
  const closeModalAceptar = () => {
    setShowModal(false)
  }

  useEffect(() => {
    if (data_usuario.length !== 0) {
      Get_RegionId_F(data_usuario.region);
    }
    // eslint-disable-next-line
  }, [data_usuario]);

  const tokenacces = localStorage.getItem("token");
  useEffect(() => {
    if (
      active_token === "" ||
      active_token === null ||
      active_token === undefined
    ) {
      Active_Token_F(localStorage.getItem("code"));
    }

    if (token === "" || token === null || token === undefined) {
      Get_Token_F(tokenacces);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenacces]);

  const ValidateBlur = (value, key) => {
    ValidaBlur(
      value,
      data_usuario,
      Get_Data_Change_F,
      Errores,
      setErrores,
      key
    );
  };

  // const CancelarIngreso = () => {

  //     window.open(
  //       `${"https://reclamosdesa-apb.superdesalud.gob.cl/home"}?run_atu=${
  //         data_usuario.run
  //       }&dv_atu=${data_usuario.dv}&nombres_atu=${
  //         data_usuario.nombre
  //       }&apellido_p_atu=${data_usuario.apellido_p}&apellido_m_atu=${
  //         data_usuario.apellido_m
  //       }`,
  //       "_self"
  //     );
  // };

  const NoPaste = (e) => {
    e.preventDefault();
    return false;
  };

  const videoContinuar = () => {
    var maxFolio = null
    var maxReclamo = null
    var lastReclamoDate = null // cambio auxiliar
    var fechaCorte = null // cambio auxiliar

    if (reclamos_temporales) {
      maxFolio = Math.max(...reclamos_temporales.map(element => { return element.folio }))
      maxReclamo = reclamos_temporales.find(reclamo => reclamo.folio === maxFolio)

      // Cambio realizado para crear reclamo con 1 creado y funcionando
      // Deja pasar si el ultimo reclamo es previo a la fecha limite
      // comentar en caso de desuso
      const auxFechaIngreso = maxReclamo.fecha_ingreso.split('-')
      lastReclamoDate = new Date(Number(auxFechaIngreso[2]), Number(auxFechaIngreso[1]) - 1, Number(auxFechaIngreso[0]))
      fechaCorte = new Date(2022, 8, 19)
    }

    if (reclamos_temporales !== null && reclamos_temporales.length !== 0 && maxReclamo !== null && !(maxReclamo.motivo_rechazo || lastReclamoDate < fechaCorte)) {
      setTemporales(true);
    } else {
      setShowForm(true)
    }
  }
  
  const direccion = () => {
    let dir = ''
    let tipo = ''
    let comuna = ''
    let region = ''

    if ( data_usuario.nacionalidad && parametros.length !== 0 ) {
      tipo = parametros.tiposdireccion.find( v => Number(v.id) === Number(data_usuario.direccion_via) ).descripcion 
    }
    if ( data_usuario.comuna && comunas.length>0 ) {
      comuna = comunas.find( c => Number(c.comuna_id) === Number(data_usuario.comuna) ).comuna_nombre
    }
    if ( data_usuario.region && parametros.length !== 0 ) {
      region = parametros.regiones.find( r => Number(r.region_id) === Number(data_usuario.region) ).region_nombre
    }

    dir = tipo + ' ' + data_usuario.direccion_nombre + ' ' + data_usuario.direccion_nro + 
          ( data_usuario.direccion_nro_dpto ? ' ' + data_usuario.direccion_nro_dpto : '' ) + ' / ' + comuna + ' / ' + region

    return dir
  }

  return (
    <>
      { ShowModal &&
        <ModalAceptar
          show = {ShowModal}
          onAccept = {onSubmit} 
          onClose = {closeModalAceptar}
          run = { data_usuario.run + "-" + data_usuario.dv }
          nombre = { data_usuario.nombres }
          apellido1 = { data_usuario.apellido_p }
          apellido2 = { data_usuario.apellido_m }
          nacimiento = { data_usuario.fecha_nacimiento }
          sexo = { ( data_usuario.sexo && parametros.length !== 0  &&
                    parametros.sexo.find( s => Number(s.id) === Number(data_usuario.sexo) ) !== undefined) &&
                    parametros.sexo.find( s => Number(s.id) === Number(data_usuario.sexo) ).descripcion }
          genero = { ( data_usuario.genero && parametros.length !== 0  &&
                      parametros.genero.find( g => Number(g.id) === Number(data_usuario.genero) ) !== undefined) &&
                      parametros.genero.find( g => Number(g.id) === Number(data_usuario.genero) ).descripcion }
          telefono = { phone_number }
          isapre = { ( data_usuario.isapre && parametros.length !== 0  &&
                      parametros.isapres.find( i => Number(i.codigo_isapre) == Number(data_usuario.isapre) ) !== undefined) &&
                      parametros.isapres.find( i => Number(i.codigo_isapre) == Number(data_usuario.isapre) ).nombre_isapre }
          // isapre = { ( data_usuario.isapre && parametros.length !== 0 ) &&
          //   parametros.isapres.find( i => i.codigo_isapre === data_usuario.isapre ).nombre_isapre }
          mail = { data_usuario.email }
          direccion = { direccion() }
          nacionalidad = { ( data_usuario.nacionalidad && parametros.length !== 0  &&
                          parametros.pais.find( n => Number(n.codigo) === Number(data_usuario.nacionalidad) ) !== undefined) &&
                          parametros.pais.find( n => Number(n.codigo) === Number(data_usuario.nacionalidad) ).gentilicio }
          comunicacion = { archivos.length !== 0 && archivos[0].name }
        />
      }

      {!primera_llamada ?

        <div style={{ display: 'flex', alignItems: 'center', width: '100%', height: '35rem', justifyContent: 'center' }}>
          <CircularProgress />
        </div>

        :

        <Container fluid>
          <Row className="pt-4 mb-3" style={{ background: "#f5f5f5" }}>
            <Col sm={12} md={12} lg={12}>
              {ShowForm &&
                <p
                  className="my-0 font-primary-ss form-ss pointer"
                  onClick={() => setShowForm(false)}
                >
                  <i className="mr-2 fas fa-arrow-left"></i>Atrás
                </p>
              }

              <h1 className="form-ss font-title-ss mb-3">
                Reclamo por alza en el precio del plan de salud
              </h1>
            </Col>
            <Col sm={12} md={12} lg={12} className="bg-primary-ss ">
              <p className="my-1 text-white form-ss">
                Información importante
              </p>
            </Col>
          </Row>

          {!ShowForm ?
            <VideoComponent
              videoContinuarFunction={videoContinuar}
            />
            :

            <Form onSubmit={showModalAceptar} className="my-3 row form-ss">
              <Form.Group className="col-12">
                <Form.Label>*RUT</Form.Label>
                <Form.Control
                  onChange={onChange}
                  name="rut"
                  value={data_usuario.run + "-" + data_usuario.dv || ""}
                  disabled
                />
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label>*Nombres</Form.Label>
                <Form.Control
                  onChange={onChange}
                  name="nombres"
                  value={data_usuario.nombres || ""}
                  className={Errores.nombres ? "error" : ""}
                  onBlur={() => ValidateBlur(data_usuario.nombres, "nombres")}
                  onPaste={(e) => NoPaste(e)}
                  autoComplete="none"
                  maxLength={100}
                  onKeyPress={(e) => onKey(e)}
                />
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label>*Apellido paterno</Form.Label>
                <Form.Control
                  onChange={onChange}
                  name="apellido_p"
                  value={data_usuario.apellido_p || ""}
                  className={Errores.apellido_p ? "error" : ""}
                  onBlur={() => ValidateBlur(data_usuario.apellido_p, "apellido_p")}
                  onPaste={(e) => NoPaste(e)}
                  onKeyPress={(e) => onKey(e)}
                  autoComplete="none"
                  maxLength={100}
                />
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label>Apellido materno</Form.Label>
                <Form.Control
                  onChange={onChange}
                  name="apellido_m"
                  value={data_usuario.apellido_m || ""}
                  onPaste={(e) => NoPaste(e)}
                  onKeyPress={(e) => onKey(e)}
                  autoComplete="none"
                  maxLength={100}
                />
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label>*Fecha de Nacimiento </Form.Label>
                <Form.Control
                  type="date"
                  name="fecha_nacimiento"
                  onChange={onChange}
                  className={Errores.fecha_nacimiento ? "error" : ""}
                  value={data_usuario.fecha_nacimiento || ""}
                  onBlur={() =>
                    ValidateBlur(data_usuario.fecha_nacimiento, "fecha_nacimiento")
                  }
                  onPaste={(e) => NoPaste(e)}
                  autoComplete="none"
                />
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label>*Sexo</Form.Label>
                <Form.Control
                  onChange={onChange}
                  name="sexo"
                  as="select"
                  value={data_usuario.sexo || ""}
                  className={Errores.sexo ? "error" : ""}
                  onBlur={() => ValidateBlur(data_usuario.sexo, "sexo")}
                >
                  <option value="">Seleccione opción</option>
                  {parametros.length !== 0 &&
                    parametros.sexo.map((data) => (
                      <option value={data.id} key={data.id}>
                        {data.descripcion}
                      </option>
                    ))}
                </Form.Control>
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label>*Género</Form.Label>
                <Form.Control
                  onChange={onChange}
                  name="genero"
                  as="select"
                  value={data_usuario.genero || ""}
                  className={Errores.genero ? "error" : ""}
                  onBlur={() => ValidateBlur(data_usuario.genero, "genero")}
                >
                  <option value="">Seleccione opción</option>
                  {parametros.length !== 0 &&
                    parametros.genero.map((data) => (
                      <option value={data.id} key={data.id}>
                        {data.descripcion}
                      </option>
                    ))}
                </Form.Control>
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label>* Teléfono Celular </Form.Label>
                <ReactPhoneInput
                  contry="cl"
                  value={phone_number}
                  inputProps={{
                    name: "telefono_uno",
                    onPaste: (e) => NoPaste(e),
                    autoComplete: "none",
                  }}
                  onChange={(phone) => Get_Phone_F(phone)}
                  onBlur={(phone) => ValidateBlur(phone, "telefono_uno")}
                  localization={es}
                  inputClass={Errores.telefono_uno ? "Errores" : ""}
                  containerClass={Errores.telefono_uno ? "error" : ""}
                  onKeyPress={(e) => onKey(e)}
                  placeholder=""
                />
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label>*Isapre</Form.Label>
                <Form.Control
                  onChange={onChange}
                  name="isapre"
                  as="select"
                  value={data_usuario.isapre || ""}
                  className={Errores.isapre ? "error" : ""}
                  onBlur={() => ValidateBlur(data_usuario.isapre, "isapre")}
                  onPaste={(e) => NoPaste(e)}
                  autoComplete="none"
                >
                  <option value="">Seleccione opción</option>
                  {parametros.length !== 0 &&
                    parametros.isapres.map((data) => (
                      <option value={data.codigo_isapre} key={data.codigo_isapre}>
                        {data.nombre_isapre}
                      </option>
                    ))}
                </Form.Control>
              </Form.Group>

              {IsAdecuando && (
                <Form.Text className="text-danger col-12 mt-0 mb-2">
                  Esta isapre no presentó reajuste en su plan de salud.
                </Form.Text>
              )}

              <Form.Group className="col-12">
                <Form.Label>*Email</Form.Label>
                <Form.Control
                  onChange={onChange}
                  name="email"
                  type="email"
                  value={data_usuario.email || ""}
                  className={Errores.email ? "error" : ""}
                  onBlur={() => ValidateBlur(data_usuario.email, "email")}
                  autoComplete="none"
                  onPaste={(e) => NoPaste(e)}
                  maxLength={100}
                />
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label>*Confirmación de Email</Form.Label>
                <Form.Control
                  onChange={onChange}
                  name="email2"
                  type="email"
                  value={data_usuario.email2 || ""}
                  className={Errores.email2 ? "error" : ""}
                  onBlur={() => ValidateBlur(data_usuario.email2, "email2")}
                  autoComplete="none"
                  onPaste={(e) => NoPaste(e)}
                  maxLength={100}
                />
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label>*Región</Form.Label>
                <Form.Control
                  onChange={onChange}
                  name="region"
                  as="select"
                  value={data_usuario.region || ""}
                  className={Errores.region ? "error" : ""}
                  onBlur={() => ValidateBlur(data_usuario.region, "region")}
                >
                  <option value="">Seleccione opción</option>
                  {parametros.length !== 0 &&
                    parametros.regiones.map((data) => (
                      <option value={data.region_id} key={data.region_id}>
                        {data.region_nombre}
                      </option>
                    ))}
                </Form.Control>
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label>*Comuna</Form.Label>
                <Form.Control
                  onChange={onChange}
                  name="comuna"
                  as="select"
                  value={data_usuario.comuna || ""}
                  className={Errores.comuna ? "error" : ""}
                  onBlur={() => ValidateBlur(data_usuario.comuna, "comuna")}
                >
                  <option value="">Seleccione opción</option>
                  {comunas.length !== 0 &&
                    comunas.map((data) => (
                      <option value={data.comuna_id} key={data.comuna_id}>
                        {data.comuna_nombre}
                      </option>
                    ))}
                </Form.Control>
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label>*Dirección vía</Form.Label>
                <Form.Control
                  onChange={onChange}
                  name="direccion_via"
                  as="select"
                  value={data_usuario.direccion_via || ""}
                  className={Errores.direccion_via ? "error" : ""}

                  onBlur={() =>
                    ValidateBlur(data_usuario.direccion_via, "direccion_via")
                  }
                >
                  <option value="">Seleccione opción</option>
                  {parametros.length !== 0 &&
                    parametros.tiposdireccion.map((data) => (
                      <option value={data.id} key={data.id}>
                        {data.descripcion}
                      </option>
                    ))}
                </Form.Control>
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label>*Nombre Dirección</Form.Label>
                <Form.Control
                  onChange={onChange}
                  name="direccion_nombre"
                  value={data_usuario.direccion_nombre || ""}
                  className={Errores.direccion_nombre ? "error" : ""}
                  onPaste={(e) => NoPaste(e)}
                  onKeyPress={(e) => onKey(e)}
                  maxLength={100}
                  autoComplete="none"
                  onBlur={() =>
                    ValidateBlur(data_usuario.direccion_nombre, "direccion_nombre")
                  }
                />
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label>*Nro Dirección</Form.Label>
                <Form.Control
                  onChange={onChange}
                  name="direccion_nro"
                  value={data_usuario.direccion_nro || ""}
                  className={Errores.direccion_nro ? "error" : ""}
                  maxLength={10}
                  onPaste={(e) => NoPaste(e)}
                  onKeyPress={(e) => onKey(e)}
                  autoComplete="none"
                  onBlur={() =>
                    ValidateBlur(data_usuario.direccion_nro, "direccion_nro")
                  }
                />
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label>Nro Departamento</Form.Label>
                <Form.Control
                  onChange={onChange}
                  name="direccion_nro_dpto"
                  onKeyPress={(e) => onKey(e)}
                  maxLength={10}
                  autoComplete="none"
                  value={data_usuario.direccion_nro_dpto || ""}
                  onPaste={(e) => NoPaste(e)}
                />
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label>*Nacionalidad</Form.Label>
                <Form.Control
                  onChange={onChange}
                  name="nacionalidad"
                  as="select"
                  value={data_usuario.nacionalidad || ""}
                  className={Errores.nacionalidad ? "error" : ""}
                  onBlur={() =>
                    ValidateBlur(data_usuario.nacionalidad, "nacionalidad")
                  }
                >
                  <option value="">Seleccione opción</option>
                  {parametros.length !== 0 &&
                    parametros.pais.map((data) => (
                      <option value={data.codigo} key={data.codigo}>
                        {data.gentilicio}
                      </option>
                    ))}
                </Form.Control>
              </Form.Group>

              {/* <div className="col-12 d-flex">
                <EjemploCartaComponent />
              </div> */}

              {/* <Col xl="12">
                <DragDrop
                  Get_Archivos_F={Get_Archivos_F}
                  archivos={archivos}
                  MaximoArchivos={20}
                  Errores={Errores}
                  setErrores={setErrores}
                />
              </Col> */}

              <Container className="my-3">
                <Button
                  type="submit"
                  className="btn-primary-ss"
                  block
                  disabled={IsAdecuando || enviando_data}
                >
                  Enviar{" "}
                  {!enviando_data ? (
                    <i className="ml-4 fas fa-arrow-right"></i>
                  ) : (
                    <div
                      className="ml-4 spinner-border text-white"
                      role="status"
                    ></div>
                  )}
                </Button>
              </Container>

              {IsAdecuando && (
                <div className="container ">
                  <p className="alert-adecuando-ss col-12 text-justify">
                    La isapre <b>{IsapreName}</b> no presentó reajuste en sus plan
                    de salud. El sistema permite el ingreso de este tipo de reclamos
                    sólo contra aseguradoras que presentaron adecuación en sus
                    planes de salud.
                  </p>
                </div>
              )}

              <hr />
              <Form.Group className="col-12">
                <Container>
                  <Row>
                    <Col sm={6} md={6}>
                      <strong>Materia Reclamada:</strong>
                      <p className="text-justify">
                        La lsapre a la que estoy afiliado(a) me ha enviado la Comunicación de Adecuación de mi Plan de Salud 
                        correspondiente al <strong>Proceso de Adecuación 2025</strong>, con la que estoy en desacuerdo, 
                        no aceptando tal decisión.
                      </p>
                    </Col>
                    <Col sm={6} md={6}>
                      <strong>Petición Concreta:</strong>
                      <p className="text-justify">
                        Solicito la intervención de la Intendencia de Fondos y Seguros Previsionales de Salud, para que revise 
                        lo informado por la isapre y resuelva el presente reclamo.
                      </p>
                    </Col>
                  </Row>
                </Container>
              </Form.Group>
              <hr />
            </Form>
          }
        </Container>

      }

      <Modal show={Temporales} centered onHide={() => false} size="lg" >
        <Modal.Header>
          <Modal.Title className="mx-auto">Aviso de reclamos ingresados</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="text-justify">
            Estimado(a), usted ya posee los siguientes ingresos por alza de precio en el plan de salud:
          </p>

          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Folio</th>
                <th>Fecha Ingreso</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {reclamos_temporales &&
                reclamos_temporales.map((dato, i) => (
                  <tr key={i}>
                    <td>{dato.folio}</td>
                    <td>{dato.fecha_hora_ingreso}</td>
                    <td>{dato.motivo_rechazo ? dato.motivo_rechazo : `En Curso`}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
          {/* <p className="text-center font-weight-bold">¿Desea continuar?</p> */}
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="secondary" onClick={() => CancelarIngreso()}>
            Ingresar otro tipo de reclamo
          </Button> */}
          <Button className="btn-primary-ss" onClick={() => setTemporales(false)}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ReclamosForm;
